module.exports = __webpack_public_path__ + "img/member_coupons_icon_431008.e6cc7222.png";